import { authenticatedFetch } from '../../../api/request';

export default async function getAllAvailabilities(doctorUserId, setErrorMessage) {
    const onError = () => setErrorMessage('No se puede obtener las disponibilidades.');
    return await authenticatedFetch(`/doctor-profile-management/all-availabilities/${doctorUserId}`, onError);
}
